import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DoctorCard from './PatientDoctorCard';
import DoctorService from '../../services/doctor.service';
import { Loader } from 'lucide-react';
import { Doctor } from '../../types/models/Doctor';

const PatientDoctorList = ({ searchTerm }) => {
 const [doctors, setDoctors] = useState([]);
 const [isLoading, setIsLoading] = useState(true);
 const [error, setError] = useState(null);

 useEffect(() => {
   loadDoctors();
 }, []);
 
 const loadDoctors = async () => {
   try {
     setIsLoading(true);
     const response = await DoctorService.getSuggested();
     const formattedDoctors = response.map(doctor => new Doctor(doctor));
     setDoctors(formattedDoctors);
   } catch (error) {
     console.error('[DEBUG] Error loading suggested doctors:', error);
     setError('Si è verificato un errore nel caricamento dei dottori suggeriti');
   } finally {
     setIsLoading(false);
   }
 };

 const filteredDoctors = doctors.filter(doctor => {
   if (!searchTerm) return true;
   
   const searchTermLower = searchTerm.toLowerCase();
   
   const matchesNameOrEmail = 
     doctor.name.toLowerCase().includes(searchTermLower) ||
     doctor.email.toLowerCase().includes(searchTermLower);
   
   const matchesTags = doctor.tags?.some(tag => 
     tag.name.toLowerCase().includes(searchTermLower)
   );
   
   return matchesNameOrEmail || matchesTags;
 });

 if (isLoading) {
   return (
     <div className="flex justify-center items-center h-64">
       <div className="flex flex-col items-center space-y-4">
         <Loader className="w-8 h-8 animate-spin text-purple-600" />
         <p className="text-gray-600">Ricerca terapeuti compatibili...</p>
       </div>
     </div>
   );
 }

 if (error) {
   return (
     <div className="text-center p-4 bg-red-50 rounded-lg">
       <p className="text-red-600">{error}</p>
       <button 
         onClick={loadDoctors}
         className="mt-2 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
       >
         Riprova
       </button>
     </div>
   );
 }

 if (filteredDoctors.length === 0) {
   return (
     <div className="text-center p-4 bg-gray-50 rounded-lg">
       <p className="text-gray-600">
         {searchTerm 
           ? "Nessun terapeuta trovato con i criteri di ricerca specificati"
           : "Nessun terapeuta compatibile al momento"}
       </p>
     </div>
   );
 }

 return (
   <div>
     {!searchTerm && (
       <div className="mb-6 p-4 bg-purple-50 rounded-lg">
         <h3 className="text-lg font-semibold text-purple-700 mb-2">Terapeuti suggeriti per te</h3>
         <p className="text-sm text-purple-600">
           In base alle tue preferenze e alle aree di interesse indicate, abbiamo selezionato questi terapeuti
           compatibili con il tuo percorso.
         </p>
         <p className="text-sm text-purple-600 mt-4">Scegli il tuo terapeuta e prenota un primo appuntamento!</p>
       </div>
     )}
     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
       {filteredDoctors.map(doctor => (
         <DoctorCard key={doctor.id} doctor={doctor} />
       ))}
     </div>
   </div>
 );
};

PatientDoctorList.propTypes = {
 searchTerm: PropTypes.string.isRequired
};

export default PatientDoctorList;